module.exports = __webpack_public_path__ + "static/kisna-cad862047f4538520c57d0033bb9363d.png";